export enum ButtonSize {
  Default = 'default',
  Small = 'small',
  Large = 'large'
}
